var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchBordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.287509,
    y: 0.754062,
    width: 19.5361,
    height: 19.5361,
    rx: 3.01354,
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.20783
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0217 15.2651C9.35894 15.2651 8.73795 15.1397 8.15874 14.889C7.57953 14.6383 7.07452 14.2976 6.64371 13.8668C6.21291 13.436 5.87216 12.931 5.62146 12.3517C5.37075 11.7725 5.2454 11.1515 5.2454 10.4888C5.2454 9.82598 5.37075 9.20499 5.62146 8.62578C5.87216 8.04657 6.21291 7.54156 6.64371 7.11075C7.07452 6.67996 7.57953 6.33921 8.15874 6.0885C8.73795 5.83779 9.35894 5.71244 10.0217 5.71244C10.6845 5.71244 11.3055 5.83779 11.8847 6.0885C12.4639 6.33921 12.9689 6.67996 13.3997 7.11075C13.8305 7.54156 14.1713 8.04657 14.422 8.62578C14.6727 9.20499 14.798 9.82598 14.798 10.4888C14.798 11.1515 14.6727 11.7725 14.422 12.3517C14.1713 12.931 13.8305 13.436 13.3997 13.8668C12.9689 14.2976 12.4639 14.6383 11.8847 14.889C11.3055 15.1397 10.6845 15.2651 10.0217 15.2651ZM11.6924 12.7516L12.2845 12.1594L10.4431 10.318V7.67915H9.60029V10.6595L11.6924 12.7516ZM6.51187 4.80688L7.10404 5.39905L4.93201 7.57108L4.33984 6.97891L6.51187 4.80688ZM13.5316 4.80688L15.7036 6.97891L15.1114 7.57108L12.9394 5.39905L13.5316 4.80688ZM10.0217 14.4222C11.1139 14.4222 12.0425 14.0397 12.8076 13.2746C13.5726 12.5095 13.9552 11.5809 13.9552 10.4888C13.9552 9.39662 13.5726 8.46801 12.8076 7.70292C12.0425 6.93784 11.1139 6.55531 10.0217 6.55531C8.92958 6.55531 8.00096 6.93784 7.23588 7.70292C6.4708 8.46801 6.08827 9.39662 6.08827 10.4888C6.08827 11.5809 6.4708 12.5095 7.23588 13.2746C8.00096 14.0397 8.92958 14.4222 10.0217 14.4222Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchBordered);
export default __webpack_public_path__ + "static/media/watchBordered.bd34cfe63c61ecdcd5610bf769c94cd1.svg";
export { ForwardRef as ReactComponent };